import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Browse from "@/pages/Browse";
import VideoView from "@/pages/VideoView";
import CategoryView from "@/pages/CategoryView";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Popunders from "@/components/ads/Popunders";
import { useAdminMode } from "@/lib/adminState";

const AdminModeAttr = () => {
  const on = useAdminMode();
  useEffect(() => {
    const root = document.documentElement;
    if (on) {
      root.dataset.adminMode = "true";
      window.XR_ADMIN_MODE = true;
    } else {
      delete root.dataset.adminMode;
      window.XR_ADMIN_MODE = false;
    }
  }, [on]);
  return null;
};

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <AdminModeAttr />
        <Popunders />
        <Navbar />
        <main className="relative z-10 min-h-[calc(100vh-80px)]">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/browse" element={<Browse />} />
            <Route path="/category/:slug" element={<CategoryView />} />
            <Route path="/video/:id" element={<VideoView />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Routes>
        </main>
        <Footer />
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#0f0f0f",
              border: "1px solid #1a1a1a",
              color: "#f2f2f2",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
